import * as React from 'react';
import { Provider, connect } from 'react-redux';
import { store } from './redux/store';
import { NoteService } from '../../services/noteService';
import INotesAppProps from './interfaces/notesAppProps';
import PinnedNotesList from './pinnedNotesList';
import { render } from '../../common/reactUtils';

class NotesApp extends React.Component<INotesAppProps, { notes: any[] }> {
    noteService: NoteService;

    constructor(props: INotesAppProps) {
        super(props);
        this.noteService = new NoteService();
        this.state = {
            notes: [], // Initialize with an empty array
        };
        this.loadData = this.loadData.bind(this);
        this.handleDragEnd = this.handleDragEnd.bind(this);
        window.addEventListener("OnPinnedNoteChanged", () => {
            this.loadData();
        })
    }

    loadData() {
        this.noteService.getPinnedNotesForUser(
            (data) => {
                this.setState({ notes: data }); // Update state with fetched data
            },
            () => {
                console.error('Failed to fetch pinned notes');
            }
        );
    }

    componentDidMount(): void {
        this.loadData();
    }

    handleDragEnd(result: any) {
        const { source, destination } = result;

        if (!destination) {
            return;
        }

        const reorderedNotes = Array.from(this.state.notes);
        const [removed] = reorderedNotes.splice(source.index, 1);
        reorderedNotes.splice(destination.index, 0, removed);

        const noteIds = reorderedNotes.map((note) => note.id);

        this.setState({ notes: reorderedNotes }, () => {
            this.noteService.updateSortOrder(
                noteIds,
                (response) => {
                    console.log("Sort order updated successfully:", response);
                },
                (error) => {
                    console.error("Failed to update sort order:", error);
                }
            );
        });
    }

    render() {
        return (
            <React.Fragment>
                <div id="hero-notes" className="notifications__list-wrapper  notifications__list-wrapper--flex pinned2">
                    <PinnedNotesList
                        items={this.state.notes}
                        onDragEnd={this.handleDragEnd}
                    />
                </div>
            </React.Fragment>
        )
    }
}

const ConnectedApp = connect(null, null)(NotesApp);

export const initialize = () => {
    render(
        <Provider store={store}>
            <ConnectedApp notes={[]} />
        </Provider>,
        '#js-react-pinnednotes-app'
    );
}